function SiteFooter({ t }) {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container site-footer-inner">
        <div className="site-footer-brand">
          <strong>{t.footerBrand}</strong>
          <span>
            © {year}. {t.footerRights}
          </span>
        </div>

        <div className="site-footer-meta">
          <span>{t.address}</span>
          <span>{t.hours}</span>
        </div>

        <div className="site-footer-social">
          <a href={t.instagramUrl} target="_blank" rel="noreferrer">
            {t.instagram}
          </a>
          <a href={t.facebookUrl} target="_blank" rel="noreferrer">
            {t.facebook}
          </a>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
